import type { TPortfolioPriceSyncStatus } from "../constants/portfolio.constants";
import type { PortfolioOptionRef, PortfolioSecurityRef } from "./portfolio-instrument";
import type { PortfolioPriceSyncOperationStatus } from "./portfolio-comparison";

export const PORTFOLIO_PRICE_UPDATED_EVENT = "portfolio-price-updated";
export const PORTFOLIO_PRICE_SYNC_EVENT = "portfolio-market-price-sync";
export type PortfolioPriceSyncEventPayload = PortfolioPriceSyncOperationStatus;

interface PortfolioPriceUpdatedBase {
  portfolioIds: string[];
  priceDate: string;
  data?: {
    operationId: string;
    cutoffDate: string;
    valuationChanged: boolean;
    status: TPortfolioPriceSyncStatus;
  };
}

/** Legacy Symbol notifications stay valid; option evidence always identifies its own account. */
export type PortfolioPriceUpdatedPayload = PortfolioPriceUpdatedBase & (
  | { symbolId: string; instrument?: PortfolioSecurityRef; accountId?: string }
  | { symbolId?: never; instrument: PortfolioOptionRef; accountId: string }
);
